import {
  CONFIGS_CHANGED,
  DELETE_CONFIG,
  DEVCON_DATA_CHANGED,
  DEVCON_DATA_LOADING,
  DOWNLOAD_CONFIG,
  GET_CONFIGS,
  DEVCON_UNMOUNTED,
  GET_DEVCON_DATA,
  LOAD_CONFIG,
  REBOOT_DEVICE,
  SAVE_CONFIG,
  SET_ADVANCED_MODE,
  SET_CONFIG,
  SET_SETTING,
  UPLOAD_CONFIG,
  WRITE_CONFIG,
} from './constants';

export const setConfig = (config, activeDeviceId) => ({type: SET_CONFIG, config, activeDeviceId});
export const setSetting = (parentSetting, setting, value) => ({type: SET_SETTING, parentSetting, setting, value});
export const setAdvancedMode = (isEnabled) => ({type: SET_ADVANCED_MODE, isEnabled});
export const getConfigs = () => ({type: GET_CONFIGS});
export const saveConfig = name => ({type: SAVE_CONFIG, name });
export const downloadConfig = () => ({type: DOWNLOAD_CONFIG });
export const uploadConfig = (file, onFail) => ({type: UPLOAD_CONFIG, file, onFail });
export const loadConfig = (name) => ({type: LOAD_CONFIG, name});
export const deleteConfig = (name) => ({type: DELETE_CONFIG, name});
export const configsChanged = (configs) => ({type: CONFIGS_CHANGED, configs});
export const rebootDevice = (deviceId) => ({type: REBOOT_DEVICE, deviceId});
export const writeConfig = (deviceId, reboot, deviceIds, onlyChanges) => ({type: WRITE_CONFIG, deviceId, reboot, deviceIds, onlyChanges});
export const getDevConData = (deviceId, force) => ({type: GET_DEVCON_DATA, deviceId, force});
export const devConDataChanged = (devConData) => ({type: DEVCON_DATA_CHANGED, devConData});
export const devConDataLoading = loading => ({type: DEVCON_DATA_LOADING, loading});
export const devConUnmounted = () => ({type: DEVCON_UNMOUNTED});
